import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateRssPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.createRssPerk,
  {
    mutationKey: ['createRssPerk'],
  },
)
